export default "__VITE_ASSET__BYBnkT9J__"